import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";

function ModalDefault(props) {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [closeButton, setCloseButton] = useState("");
  const [backdrop, setBackdrop] = useState("");
  const [size, setSize] = useState("");
  const [fullscreen, setFullscreen] = useState(false);

  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  useEffect(() => {
    if (props.message) setMessage(props.message);
    if (props.closeButton) setCloseButton(props.closeButton);
    if (props.show) setShow(props.show);
    if (props.backdrop) setBackdrop(props.backdrop);
    if (props.size) setSize(props.size);
    if (props.fullscreen) setFullscreen(props.fullscreen);
  }, [props]);

  return (
    <>
      <Modal
        id='modalDefault'
        show={show}
        onHide={handleClose}
        backdrop={backdrop}
        size={size}
        fullscreen={fullscreen}
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Atenção!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            {closeButton}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalDefault;
